import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const Ticket = ({match}) => (
  <div className="app-wrapper">
    <Switch>
       <Route path={`${match.url}/ticket`} component={asyncComponent(() => import('./routes/ticket'))}/>
       <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default Ticket;